import { AxiosResponse } from 'axios'

import { APIDiagnostic } from '@/type/things/diagnostic'
import fetchApi from '@/utils/axios'
import { sentryFetchError } from '@/utils/sentry'

export default {
  async getCompositeDiagnostic({ commit }: any, { serial }: any) {
    try {
      const response: AxiosResponse<APIDiagnostic> = await fetchApi.get(`/thing/${serial}/diagnostic`)
      commit('diagnostic/setCompositeDiagnostic', { response: response.data, serial }, { root: true })
    } catch (error) {
      sentryFetchError(error.response)
      commit('notification/addNotification', error.response, { root: true })
    }
  }
}
